import React, { useEffect, useState } from 'react'
import { useFilter } from '../../forms/hocs/filter.context.hoc'
import { StyledSearchFilterSelectContainer, StyledCheckboxForm } from './search-filters-checkbox.styles'
import { SearchFiltersCheckbox } from './search-filters-checkbox'
import { InfoBannerWrapper } from '../info-banner/info-banner.styles'
import { InfoBannerHeader } from './fuel-type-search-filters-checkboxes.styles'
import { Option } from '../../forms/hocs/types'

type OptionsSplit = {
    optionsBeforeHybrid: ReadonlyArray<Option>
    hybridOption: Option | null
    optionsAfterHybrid: Option[]
}
export const splitOptionsOnHybrid = (
    options: ReadonlyArray<Option>,
    availableHybridValues: ReadonlyArray<string>
): OptionsSplit => {
    const indexOfHybrid = options.findIndex((option) => option.value === 'Hybrid')
    if (indexOfHybrid >= 0) {
        const optionsBeforeHybrid = options.slice(0, indexOfHybrid)
        const hybridOption = options[indexOfHybrid]
        const optionsAfterHybridIncludingHybridValues = options.slice(indexOfHybrid + 1)
        const optionsAfterHybrid = optionsAfterHybridIncludingHybridValues.filter(
            (option) => !availableHybridValues.includes(option.value)
        )
        return {
            optionsBeforeHybrid,
            hybridOption,
            optionsAfterHybrid,
        }
    }

    return {
        optionsBeforeHybrid: options,
        hybridOption: null,
        optionsAfterHybrid: [],
    }
}

export const FuelTypeSearchFiltersCheckboxes = () => {
    const { options, hybridOptions, selected, isDisabled } = useFilter()
    const hasHybridSubOptions = hybridOptions.length > 0
    const availableHybridOptions = options.filter((option) => hybridOptions.includes(option.value))
    const availableHybridValues = availableHybridOptions.map((option) => option.value)
    const hybridOptionsSelected = availableHybridValues.some((value) => selected.includes(value))

    const [showHybridOptions, setShowHybridOptions] = useState(hybridOptionsSelected)
    useEffect(() => {
        if (selected.some((option) => availableHybridValues.includes(option))) {
            setShowHybridOptions(true)
        }
    }, [selected, availableHybridValues])

    const { optionsBeforeHybrid, hybridOption, optionsAfterHybrid } = splitOptionsOnHybrid(
        options,
        availableHybridValues
    )

    return (
        <StyledCheckboxForm>
            <StyledSearchFilterSelectContainer>
                {optionsBeforeHybrid.map((option) => (
                    <SearchFiltersCheckbox key={option.label} option={option} />
                ))}

                {hybridOption ? (
                    <SearchFiltersCheckbox
                        option={hybridOption}
                        overrideValue={hasHybridSubOptions ? [...availableHybridValues] : undefined}
                    />
                ) : null}

                {showHybridOptions && availableHybridValues.length ? (
                    <InfoBannerWrapper as="div" $disabled={isDisabled}>
                        <InfoBannerHeader as="p">What type of hybrid vehicle are you looking for?</InfoBannerHeader>
                        {availableHybridOptions.map((option) => (
                            <SearchFiltersCheckbox
                                key={option?.label}
                                option={{ ...option, count: null }}
                                invertColours
                            />
                        ))}
                    </InfoBannerWrapper>
                ) : null}

                {optionsAfterHybrid.map((option) => (
                    <SearchFiltersCheckbox key={option.label} option={option} />
                ))}
            </StyledSearchFilterSelectContainer>
        </StyledCheckboxForm>
    )
}
